export { default } from './CircularProgress';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/CircularProgress/index.js
// module id = 173
// module chunks = 2